import cookies from './util.cookies'

import Setting from '@/setting'

const util = {
    cookies
};
/**
 * @description 更改标题
 * @param {Object} title 标题
 */
util.title = function ({ title }) {
  window.document.title = title ? `${title} - ${Setting.titleSuffix}` : Setting.titleSuffix;
};
util.isMobile = function () {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
};
export default util;
